'use client'
import { Box, styled } from '@mui/material'
import Logo from 'assets/images/png/yellow-logo.png'
import { useSensors } from 'hooks/useSensors'
import { openApp } from 'utils/openApp'

const RightBox = styled(Box)`
  height: 28px;
  width: 72px;
  flex-shrink: 0;
  border-radius: 20px;
  background-color: #f6ff4a;
  text-align: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 28px;
  color: #000000;
  cursor: pointer;
`
const LeftBox = styled(Box)`
  display: flex;
  width: 100vw;
  overflow: hidden;
  img {
    width: 35px;
    height: 35px;
    margin-right: 9px;
  }
`
const HeaderBox = styled(Box)`
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  width: 100vw;
  overflow: hidden;
  background: #141414;
  background-color: #141414;
  z-index: 1;
  padding: 13px 15px;
  align-items: center;
  .title {
    font-weight: 600;
    line-height: 20px;
  }
  .desc {
    height: 14px;
    width: 160vw;
    transform: scale(0.625);
    transform-origin: top left;
  }
  @media (min-width: 768px) {
    display: none;
  }
`
export function DownloadHeaderH5() {
  const { sensorsTrack } = useSensors()

  return (
    <HeaderBox>
      <LeftBox>
        <img width={35} height={35} src={Logo} alt={'yeeha logo'} />
        <div>
          <div className="title">Yeeha</div>
          <div className="desc">Create Together · Play Together</div>
        </div>
      </LeftBox>
      <RightBox
        onClick={() => {
          sensorsTrack('H5DownloadTopClick', {
            url: window.location.href,
          })
          openApp()
        }}
      >
        open
      </RightBox>
    </HeaderBox>
  )
}
